// ============================================
// ITEM SYSTEM - アイテムの更新
// ============================================

import { getP5 } from '../../core/p5-instance';
import { CONFIG } from '../../config/game-config';
import { getItems, getPlayer } from '../../store';
import { applyItem } from '../../features/items/item';
import { createCollectParticles } from '../../features/particles/particles';

/**
 * updateItems() - アイテムの更新
 */
export function updateItems(dt: number): void {
    const p = getP5();
    const items = getItems();
    const player = getPlayer();
    if (!player) {
        return;
    }

    for (let i = items.length - 1; i >= 0; i--) {
        items[i].y += CONFIG.itemSpeed * dt;
        items[i].rotation += 0.05 * dt;

        if (p.dist(items[i].x, items[i].y, player.x, player.y) < player.size / 2 + items[i].size / 2 && player.state?.name === 'Normal') {
            applyItem(items[i].type);
            createCollectParticles(items[i].x, items[i].y, items[i].color);
            items.splice(i, 1);
            continue;
        }

        if (items[i].y > p.height + 30) {
            items.splice(i, 1);
        }
    }
}
